import { motion, useReducedMotion } from 'framer-motion';
import { Card } from 'root/src/client/v2/common/components/ui/card';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// The card every redesign error surface is built from: the 404 page, the 500 page and the
// ErrorBoundary fallback. It mirrors the VerificationStatePage look (icon tile + font-display title +
// muted copy) so an error reads like the rest of the app rather than a dead end.
//
// Deliberately provider-free: no tRPC, no redux, no MUI theme, no tooltip context. Two of its three
// callers render OUTSIDE the app providers, because `_app` short-circuits `/500` before mounting them
// and the top-level ErrorBoundary fallback replaces the whole tree that failed.
//
// Content is static, so there is no layout shift; the card enters with one gentle fade / slide, which
// reduced-motion users do not get.
export const RedesignErrorCard = ({ icon, iconTileClassName, eyebrow, title, children, actions }) => {
    const reducedMotion = useReducedMotion();
    return (<motion.div initial={reducedMotion ? false : { opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.25, ease: 'easeOut' }} className="w-full">
			<Card className="flex flex-col items-center gap-4 px-6 py-14 text-center sm:px-10">
				<div className={cn('flex h-14 w-14 items-center justify-center rounded-2xl', iconTileClassName)}>{icon}</div>
				<div className="flex flex-col items-center gap-1">
					{eyebrow ? <span className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">{eyebrow}</span> : null}
					<h1 className="font-display text-2xl font-bold text-foreground sm:text-3xl">{title}</h1>
				</div>
				<div className="max-w-md space-y-2 text-sm leading-relaxed text-muted-foreground">{children}</div>
				{actions ? <div className="mt-2 flex flex-wrap items-center justify-center gap-3">{actions}</div> : null}
			</Card>
		</motion.div>);
};
